import { endpoints } from '../../../config/connections'
import { getLocale } from '../../../utils/sessionUtils'
import { SPANISH_LANG_CODE } from '../../../constants/lang'

const getAemProductURL = () => {
  const { digitalDisclaimer } = endpoints

  return digitalDisclaimer
}

const getAemBaseURL = () => {
  const { baseDigital, baseDigitalSp } = endpoints

  if (getLocale() === SPANISH_LANG_CODE) {
    return baseDigitalSp
  }
  return baseDigital
}

export const aemContentFormattedData = (aemData = null) => {
  const contentElements =
    (aemData && aemData[':items']?.root[':items']?.contentfragment?.elements) ??
    {}
  const formattedData = {}
  Object.keys(contentElements).forEach((key) => {
    formattedData[key] = contentElements[key].value
  })
  return formattedData
}

const DisclaimerService = (() => {
  const getDisclaimerContent = () => {
    const baseAemUrl = getAemBaseURL()
    const baseAemProductUrl = getAemProductURL()

    return `${baseAemUrl}${baseAemProductUrl}`
  }
  return { getDisclaimerContent }
})()

export default DisclaimerService
